
export class Branch {
    private _id: string;
    private _version: string;
    private _zones: string[];

    constructor(id: string = null, version: string = null, zones: string[] = null) {
        this._id = id;
        this._version = version;
        this._zones = zones;
    }

    public get id(): string {
        return this._id;
    }

    public get version(): string {
        return this._version;
    }

    public get zones(): string[] {
        return this._zones;
    }
}
